import { Platform, StyleSheet } from 'react-native';

import Fonts from '../../Themes/Fonts';

export default StyleSheet.create({
  text: {
    fontSize: Platform.OS === 'ios' ? 16.6 : 20,
    alignSelf: 'center',
    lineHeight: 20,
  },
  textColor: theme => ({
    color: theme.colors.textColorTwo,
    textAlign: 'center',
  }),
  activeMainView: {},
  activeText: {
    ...Fonts.type.bold,
    fontSize: Platform.OS === 'ios' ? 16.6 : 22,
    fontWeight: 'bold',
    lineHeight: 20,
  },
  activeTextColor: theme => ({
    color: theme.colors.headerColor,
    textAlign: 'center',
  }),
});
